define('apps/course-intro/routes/router',[], function () {
    "use strict";

    return Mn.AppRouter.extend({

        "appRoutes": {
            "": "chooseLevels",
            "choose-levels": "chooseLevels",
            "choose-modules/:levelNum/:levelGuid": "chooseModules",
            "materials/:levelNum/:levelGuid": "doMaterials",
            'badges/:levelNum/:levelGuid': "getBadges"
        }
    });
});

